/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { SiteShareFormFromJSON, SiteShareFormToJSON } from './SiteShareForm';
export function GetContactShareSiteShareFormsResponseDataFromJSON(json) {
    return GetContactShareSiteShareFormsResponseDataFromJSONTyped(json, false);
}
export function GetContactShareSiteShareFormsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        shareForms: !exists(json, 'share_forms')
            ? undefined
            : json['share_forms'].map(SiteShareFormFromJSON)
    };
}
export function GetContactShareSiteShareFormsResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        share_forms: value.shareForms === undefined ? undefined : value.shareForms.map(SiteShareFormToJSON)
    };
}
